import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, Form, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ISdVoteDto } from '../../../shared/models/sd/sd-vote';

@Component({
    selector: 'app-sd-certificate-of-appreciation',
    templateUrl: './sd-certificate-of-appreciation.component.html',
    styleUrl: './sd-certificate-of-appreciation.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SdCertificateOfAppreciationComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class SdCertificateOfAppreciationComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() committeeMember!: ISdVoteDto;

  isDisabled: boolean = false;
  onChange: (value: any) => void = () => { };
  onTouched: any = () => { };

  subscriptions: Subscription = new Subscription();

  formGroup: FormGroup = new FormGroup({
    yesNoCtrl: new FormControl(),
  });

  get yesNoCtrl() {
    return this.formGroup.get('yesNoCtrl') as FormControl;
  }

  ngOnInit(): void {
    this.subscribeToFormChanges();
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  subscribeToFormChanges() {
    this.subscriptions.add(
      this.formGroup.valueChanges.subscribe((formValue) => {
        this.onChange(formValue.yesNoCtrl);
      })
    );
  }

  writeValue(obj: any): void {
    if (obj === undefined || obj === null) {
      this.yesNoCtrl.setValue(null, { emitEvent: false });
    }
    else {
      this.yesNoCtrl.setValue(!!obj, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

}
